import { combineReducers } from "@reduxjs/toolkit";
import loaderReducer from "src/components/loader/reducer";
import snackbarReducer from "src/components/snackbar/reducer";
import authReducer from "src/apps/auth/redux";

export const APP_NAME = "lpg-shnerp"

export const APP_REDUCER = combineReducers({
    loader: loaderReducer,
    snackbar: snackbarReducer,
    auth: authReducer,
})

export const PERSIST_BLACKLIST_REDUCERS = ["loader", "snackbar"]
